// import * as api from "@/api/user";
// import * as cookie from "@/utils/cookie";
// import { Message, MessageBox } from "element-ui";
const state = {
    userInfo: {},
    menusStore: [],
    menus: [],
    menusDefult: [
        {
            label: "平台概览",
            value: "/",
            icon: "el-icon-s-home",
            operation: [],
            btns: []
        },
        {
            icon: "el-icon-s-custom",
            value: "/user",
            label: "业务人员",
            operation: ["see"],
            btns: ["see","add","batch","edit","delete"]
        },
        {
            icon: "el-icon-s-cooperation",
            label: "物品管理",
            value: "/search_list",
            children: [
                {
                    value: "/search_list",
                    p_value: "/search_list",
                    label: "物品查找",
                    operation: [],
                    btns: ["batch"]
                },
                {
                    value: "/classification_list",
                    p_value: "/search_list",
                    label: "物品类型",
                    operation: ["see"],
                    btns: ["see","add","edit","delete"]
                }
            ]
        },
        {
            icon: "el-icon-s-check",
            label: "交易管理",
            value: "/transaction_list",
            operation: [],
            btns: []
        },
        {
            icon: "el-icon-s-help",
            label: "找物管理",
            value: "/goods_list",
            children: [
                {
                    value: "/goods_list",
                    p_value: "/goods_list",
                    label: "关注物品",
                    operation: ["see"],
                    btns: ["see","add","edit","delete"]
                },
                {
                    value: "/people_list",
                    p_value: "/goods_list",
                    label: "关注人物",
                    operation: ["see"],
                    btns: ["see","add","edit","delete"]
                }
            ]
        },
        {
            icon: "el-icon-s-custom",
            label: "用户管理",
            value: "/subaccount_list",
            children: [
                {
                    value: "/subaccount_list",
                    p_value: "/subaccount_list",
                    label: "子账户管理",
                    operation: ["see"],
                    btns: ["see","add","edit","delete"]
                },
                {
                    value: "/addressbook_list",
                    p_value: "/subaccount_list",
                    label: "通讯录",
                    operation: ["see"],
                    btns: ["see","add","edit","delete"]
                }
            ]
        },
        {
            icon: "el-icon-s-tools",
            label: "系统管理",
            value: "/operation_list",
            children: [
                {
                    value: "/sys_user_list",
                    p_value: "/operation_list",
                    label: "管理员",
                    operation: ["see"],
                    btns: ["see","add","edit","delete"]
                },
                {
                    value: "/organization_man",
                    p_value: "/operation_list",
                    label: "机构管理",
                    operation: ["see"],
                    btns: ["see","add","edit","delete"]
                },
                {
                    value: "/role_man",
                    p_value: "/operation_list",
                    label: "角色管理",
                    operation: ["see"],
                    btns: ["see","add","edit","delete"]
                },
                {
                    value: "/menu_man",
                    p_value: "/operation_list",
                    label: "菜单管理",
                    operation: [],
                    btns: []
                },
                {
                    value: "/operation_list",
                    p_value: "/operation_list",
                    label: "操作日志",
                    operation: [],
                    btns: []
                }
            ]
        }
    ]
}

const getters = {
    getter_userinfo: state => state.userinfo,
    getter_menusStore: state => state.menusStore,
    getter_menusDefult: state => state.menusDefult,
    getter_menus: state => state.menus,
}

const mutations = {
    setUserInfo(state, payload){
        state.userinfo = payload
    },
    setMenusStore(state, payload){
        state.menusStore = payload
    },
    setMenus(state, payload){
        state.menus = payload
    },
    // setMenusDefult(state, payload){
    //     state.menusDefult = payload
    // },
}

const actions = {
}

export default {
    state,
    getters,
    mutations,
    actions
}

// export default {
//   namespaced: true,
//   state: {
//     userInfo: {},
//     menusStore: [
        
//     ],
//     menus: [],
//     menusDefult: [
//         {
//             label: "平台概览",
//             value: "/",
//             icon: "el-icon-s-home"
//         },
//         {
//             icon: "el-icon-s-custom",
//             value: "/user",
//             label: "用户管理"
//         },
//         {
//             icon: "el-icon-s-cooperation",
//             label: "物品管理",
//             value: "/search_list",
//             children: [
//                 {
//                     value: "/search_list",
//                     label: "物品查找"
//                 },
//                 {
//                     value: "/classification_list",
//                     label: "类别管理"
//                 }
//             ]
//         },
//         {
//             icon: "el-icon-s-check",
//             label: "交易管理",
//             value: "/transaction_list"
//         },
//         {
//             icon: "el-icon-s-help",
//             label: "找物管理",
//             value: "/goods_list",
//             children: [
//                 {
//                     value: "/goods_list",
//                     label: "关注物品"
//                 },
//                 {
//                     value: "/people_list",
//                     label: "关注人物"
//                 }
//             ]
//         },
//         {
//             icon: "el-icon-s-tools",
//             label: "系统管理",
//             value: "/operation_list",
//             children: [
//                 {
//                     value: "/operation_list",
//                     label: "操作记录"
//                 },
//                 {
//                     value: "/sys_admin",
//                     label: "系统用户"
//                 }
//             ]
//         }
//     ]
//   },
//   getters: {
//     getter_menusDefult: state => state.menusDefult,
//   },
//   mutations: {
//     setUserInfo(state, payload){
//         state.userinfo = payload
//     },
//     setMenusStore(state, payload){
//         state.menusStore = payload
//     },
//     setMenus(state, payload){
//         state.menus = payload
//     },
//     setMenusDefult(state, payload){
//         state.menusDefult = payload
//     },
//   },
//   actions: {
//   }
// };
